import "./index.css";
import React, { useState, useEffect } from "react";
import { Button, message, Form, Input, Divider, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import { useParams, useHistory } from "react-router-dom";
import ReactGA from "react-ga";

import { withHansaCreateLink } from "../../store/actions/generate-withhansa-link";
import { getHansaAccount } from "../../store/actions/get-hansa-account";

import Loader from "../../components/Loader";
import useQuery from "../../utils/useQuery";

const PlaidPage = () => {
  const dispatch = useDispatch();
  const withHansaCreateLinkState = useSelector((s) => s.withHansaCreateLink);  
  const HansaAccountState = useSelector((s) => s.getHansaAccount);
  //const cAccountId = useQuery().get("accountid");
  const [displayMsg, setDisplayMsg] = useState('');
  const [reportUrl, setReportUrl] = useState('');
  const [disableGenerateBTN,  setDisableGenerateBTN] = useState(false);

  const [accountName, setAccountName] = useState('');
  const [taxId, setTaxId] = useState('');
 

  const handleGenerateReport = (values) => {    
   //dispatch(withHansaCreateLink({ accountId: cAccountId }));   //http://localhost:3002/withhansa?accountid=001q0000013ivw5AAA    
   dispatch(withHansaCreateLink({}));
  };

  useEffect(() => {
    console.log('MRA withHansaCreateLinkState:', withHansaCreateLinkState);
    if(withHansaCreateLinkState.error){
      setDisplayMsg(withHansaCreateLinkState.error);
      setReportUrl('');
    }else if(withHansaCreateLinkState.data){
      setReportUrl(withHansaCreateLinkState.data);
      setDisplayMsg('');
      setDisableGenerateBTN(true);
      setTimeout(() => {
        setDisableGenerateBTN(false);
      }, 20000)
    }
   
  }, [withHansaCreateLinkState]);

  useEffect(() => {
    console.log('MRA HansaAccountState:', HansaAccountState);
    if(HansaAccountState.data && HansaAccountState.data.AccountName && HansaAccountState.data.TaxId){
      setAccountName(HansaAccountState.data.AccountName);
      setTaxId(HansaAccountState.data.TaxId);
    }    
  }, [HansaAccountState]);

  useEffect(() => {
    dispatch(getHansaAccount({}));
    dispatch(withHansaCreateLink({}));
  }, []);

  return (
    <div className="container plaid-page">
      <div className="content">
        <Row>
          <Col className="mr-auto ml-auto order-1 order-md-2" md="8" sm="12">
            <Card>
              <CardTitle className="text-center p-4">
                <h2 className="sos-text-primary mb-0 font-weight-bold">
                  WithHansa
                </h2>
              </CardTitle>
              { taxId ?
                <>
                  <CardTitle className="text-center p-4">
                    <div>Business identifier (EIN) : {taxId} - Account Name: {accountName}</div>
                  </CardTitle>
                  <CardBody>
                    <Loader               
                    >                
                        {/*
                        <section className="text-center">
                          <Form
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            name="generate-report"
                            onFinish={handleGenerateReport}
                            className="p-4 justify-content-center"
                            layout="inline"
                          >                       
                            <Form.Item>
                              <Button htmlType="submit" className="sos-bg-primary text-white" disabled={disableGenerateBTN}>
                                Generate Report
                              </Button>
                            </Form.Item>
                          </Form>
                        </section>
                        */}
                        <h4 className="text-center mt-0">
                        {displayMsg}
                        </h4>
                    </Loader>
                  </CardBody>
                </>:null}
            </Card>            
          </Col>
        </Row>
        { reportUrl ? <iframe src={reportUrl} width="100%" height="800px" title="Withhansa" />:null }
      </div>
    </div>
  );
};

export default PlaidPage;
